// extracted by mini-css-extract-plugin
export var boxItems = "_9g-1";
export var boxItemsLg = "_9g-2";
export var button = "_9g-7";
export var buttonHoverless = "_9g-9";
export var buttonLg = "_9g-8";
export var filterGroupBox = "_9g-0";
export var icon = "_9g-3";
export var iconSecondary = "_9g-6";
export var iconWrapper = "_9g-4";
export var iconWrapperLg = "_9g-5";
export var truncatedLabel = "_9g-a";